export const SET_MODAL_IS_OPEN = 'SET_MODAL_IS_OPEN';

// Actions
export const setIsModalOpen = (isOpen) => ({
  type: SET_MODAL_IS_OPEN,
  isOpen,
});

// Selectors
export const getIsModalOpen = (state) => state.modalState.isOpen;

// Reducer
const INITIAL_STATE = {
  isOpen: false,
};

const modalState = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_MODAL_IS_OPEN:
      return {
        ...state,
        isOpen: action.isOpen,
      };
    default:
      return state;
  }
};
export default modalState;
